export default __webpack_public_path__ + "static/media/logo.b77e8109.svg";